import { useCallback, useContext } from "react";

import { FormType, OrganizationCountry, FormCategory } from "@simplyk/common";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { FrontendFormContext } from "@/common/contexts/FrontendFormContext";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";

export const useTrackFormLogoClicked = ({
  formType,
  formCategory,
  country,
  formStep,
}: {
  formType: FormType;
  formCategory: FormCategory;
  country?: OrganizationCountry;
  formStep: 1 | 2;
}) => {
  const { logAmplitudeEvent } = useAmplitude();
  const { formAmplitudeContext } = useContext(FrontendFormContext);

  return useCallback(() => {
    logAmplitudeEvent(AmplitudeEvents.LearnMoreAboutZeffyViewed, {
      form_type: formType,
      form_category: formCategory,
      organization_country: country,
      form_step: formStep === 1 ? "Step 1 - Selection" : "Step 2 - Checkout",
      ...formAmplitudeContext,
    });
  }, [formType, formCategory, country, formStep, logAmplitudeEvent, formAmplitudeContext]);
};
